import type { FunctionComponent } from 'react';

import HomePointPinIcon from 'components/icons/HomePointPinIcon';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const HomePointMarker: FunctionComponent<Props> = ({ ariaLabel, className, testId = TEST_ID }) => (
    <div
        aria-label={ariaLabel}
        className={`${styles.homePointMarker} ${className ?? ''}`}
        data-testid={testId}>
        <HomePointPinIcon />
    </div>
);

export default HomePointMarker;
